import SelectWithSearch from "@/components/ui/select-search";
import AuthContext from "@/store/contexts/AuthContext";
import { useContext } from "react";

const ModelSelection = ({
  model,
  onChange,
}: {
  model: string;
  onChange: (model: string) => void;
}) => {
  const { models } = useContext(AuthContext);
  return (
    <div className="px-4">
      <SelectWithSearch
        placeholder="Selection du modèle"
        noFoundPlaceholder="Aucun modèle trouvé"
        options={models}
        onChange={onChange}
        value={model}
      />
    </div>
  );
};

export default ModelSelection;
